import PropTypes from "prop-types"
import { IconButton } from "@mui/material"
import Tooltip from "components/material/tooltip"
import { MoreVert } from "@mui/icons-material"
import { hasPermission, PERMISSION_LEVELS } from "helpers/permissions"

export default function EditButton({ resource, setResource, setEditAnchor }) {
  const canEdit = hasPermission(resource.permissionLevel, PERMISSION_LEVELS.WRITE)
  const button = <IconButton
    disabled={!canEdit}
    onClick={(e) => {
      setResource(resource)
      setEditAnchor(e.currentTarget)
    }}
    size="large"
  >
    <MoreVert />
  </IconButton>

  return canEdit ? button : <Tooltip title="You do not have the permissions to edit this resource">
    <span>
      {button}
    </span>
  </Tooltip>
}

EditButton.propTypes = {
  resource: PropTypes.object.isRequired,
  setResource: PropTypes.func.isRequired,
  setEditAnchor: PropTypes.func.isRequired,
}
